import { Field, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { IcsFeedTypeEnum } from '../IcsFeedTypeEnum'

@InputType()
export class GenerateIcsFeedArgs extends ActionArgs {
  @Field(() => String)
  type: IcsFeedTypeEnum

  @Field(() => String, { nullable: true })
  baseUrl?: string
}

export interface IGenerateIcsFeed extends IAction<string, GenerateIcsFeedArgs> {}
